import React from "react"

interface EventImageProps {
    imageUrl: string
}

/**
 * Component to display event photo
 */
function EventImage({ imageUrl }: EventImageProps) {
    if (!imageUrl) {
        return null
    }

    const handleImageClick = () => {
        window.open(imageUrl, '_blank')
    }

    return (
        <div className="tile operator-info">
          <h6>Photo</h6>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', paddingBottom: '30px' }}>
            <img 
              src={imageUrl} 
              alt="Event documentation" 
              style={{ 
                  maxWidth: '100%', 
                  maxHeight: '200px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: 'pointer'
              }}
              onClick={handleImageClick}
            />
          </div>
      </div>
    )
}

export default EventImage
